// The venue record's fields on the Venue profile settings group (spec/13 §13; #403), in order, and the
// panel each sits in. Kept apart from `venue-source.ts` — which reads the contract's schemas at build
// time — so the command palette's settings search (`settings/search.ts`) can name them without
// loading the renderer.

import type { UpdateVenue } from '@clavian/api-client';

/** The fields on the screen, in order, and the panel each sits in. `status` is not one (see below). */
export const FIELDS = [
  { key: 'name', section: 'details' },
  { key: 'slug', section: 'details' },
  { key: 'timezone', section: 'details', setupOnly: true },
  // ADR-0029: a trading venue may move its cutoff; the change takes effect from the next business day.
  { key: 'businessDayCutoff', section: 'details' },
  { key: 'address', section: 'location' },
  { key: 'coordinate', section: 'location' },
  { key: 'contact', section: 'contact' },
  { key: 'openingHours', section: 'hours' },
  // The holiday calendar as a list of dated rows, each added and edited in a small dialog (`HolidaysControl`).
  { key: 'holidays', section: 'holidays', control: 'holidays' },
  { key: 'amenities', section: 'offer' },
  { key: 'publicListing', section: 'offer' },
  { key: 'logoFileId', section: 'logo', control: 'logo' },
  { key: 'photos', section: 'photos', control: 'photos' },
] as const satisfies readonly {
  key: keyof UpdateVenue;
  section: string;
  setupOnly?: boolean;
  control?: string;
}[];
// `status` (setup → live ⇄ paused) is on `UpdateVenue` but is not one of the form's fields: going live is a
// decision with consequences of its own, so it has its own control at the head of the group, with a confirm
// (`VenueStatus.tsx`, spec/13 §13).

export type VenueField = (typeof FIELDS)[number]['key'];
